import { jsxs as o, jsx as e } from "react/jsx-runtime";
import * as n from "react";
import { cn as c } from "../../../lib/utils.js";
import { motion as f, AnimatePresence as w } from "framer-motion";
const b = n.forwardRef(({ className: p, checked: r = !1, onCheckedChange: a, label: s, description: l, size: x = "md", disabled: m }, h) => {
  const [t, d] = n.useState(r);
  n.useEffect(() => {
    d(r);
  }, [r]);
  const g = () => {
    if (m)
      return;
    const u = !t;
    d(u), a == null || a(u);
  }, i = {
    sm: { track: "h-5 w-9", thumb: "h-3.5 w-3.5", translate: 16 },
    md: { track: "h-7 w-12", thumb: "h-5 w-5", translate: 20 },
    lg: { track: "h-9 w-16", thumb: "h-7 w-7", translate: 28 }
  }[x];
  return o("div", { ref: h, className: c("inline-flex items-center gap-4 group cursor-pointer select-none", m && "cursor-not-allowed opacity-40", p), onClick: g, children: [o("div", { className: c("relative flex items-center rounded-full p-1 transition-colors duration-500", t ? "bg-lpr-teal dark:bg-lpr-gold shadow-luxury" : "bg-bg-muted border border-color/5", i.track), children: [e(f.div, { initial: !1, animate: {
    x: t ? i.translate : 0,
    scale: t ? 1 : 0.9,
    backgroundColor: t ? "#fff" : "#94a3b8"
  }, transition: {
    type: "spring",
    stiffness: 500,
    damping: 30,
    mass: 1
  }, className: c("rounded-full shadow-subtle z-10", i.thumb) }), e(w, { children: t && e(f.div, { initial: { opacity: 0, scale: 0.8 }, animate: { opacity: 0.2, scale: 1 }, exit: { opacity: 0, scale: 0.8 }, className: "absolute inset-0 rounded-full bg-white blur-md" }) })] }), (s || l) && o("div", { className: "flex flex-col", children: [s && e("span", { className: "text-xs font-medium text-text-secondary group-hover:text-lpr-teal dark:group-hover:text-lpr-gold transition-colors", children: s }), l && e("span", { className: "text-xs font-medium text-text-secondary/40 leading-tight italic", children: l })] })] });
});
b.displayName = "Switch";
export {
  b as Switch
};
//# sourceMappingURL=Switch.js.map
